import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetch a single authorized PO record by id (h_po_authorized_records.id)
 * @param {number|string} poId
 * @returns {Promise<object|null>}
 */
export const getAuthorizedPoById = async (poId) => {
  try {
    if (poId == null || poId === '') {
      return null;
    }
    const response = await apiClient.get(
      `/adminInvoiceManagement/purchaseOrderManagement/authorized-records/${poId}`
    );
    return response.data?.response ?? response.data ?? null;
  } catch (error) {
    handleApiError(error);
    return null;
  }
};
